import getDestinationsByDate from "./getDestinationsByDate";

export default (destinations=[], id)=>{
    return getDestinationsByDate(destinations).find(d => (
        d.id === id
    ));
}